module.exports = __webpack_public_path__ + "static/media/fachada4.d80beadf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Fachada/fachada4.jpg
// module id = 326
// module chunks = 0